import {createSlice} from '@reduxjs/toolkit';
import {IDLE} from '@constants/loadingState';

interface ErrorsList {
  msg: string;
  type: string;
  loc: string[];
  input: string;
  ctx: {reason: string};
};

interface CommonState {
  loading: string;
  errors_list: ErrorsList[];
  error: string;
  success_message: string;
  modal_title: string;
  modal_button_text: string;
};

const initialState: CommonState = {
  loading: IDLE,
  errors_list: [],
  error: '',
  success_message: '',
  modal_title: '',
  modal_button_text: '',
};

const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setErrors(state, action) {
      state.error = action.payload?.error;
    },
    setErrorsList(state, action) {
      state.errors_list = action.payload?.errors_list;
    },
    setSuccessMessage(state, action) {
      state.success_message = action.payload.success_message;
      state.modal_title = action.payload.modal_title;
      state.modal_button_text = action.payload.modal_button_text;
    },
    removeError(state) {
      state.error = '';
    },
    removeSuccessMessage(state) {
      state.success_message = '';
      state.modal_title = '';
      state.modal_button_text = '';
    },
    removeErrorsList(state) {
      state.errors_list = [];
    },
    removeErrorsFromList(state, action) {
      const newErrorsList: ErrorsList[] = [];
      state.errors_list.map(function (error) {
        let remove = false;
        error.loc.map(function (loc) {
          action.payload.names.map(function (name: string) {
            if (name === loc) {
              remove = true;
            }
          });
        });
        if (!remove) {
          newErrorsList.push(error);
        }
      });
      state.errors_list = newErrorsList;
    },
  },
});


export const {
  setErrors,
  setErrorsList,
  setSuccessMessage,
  removeError,
  removeSuccessMessage,
  removeErrorsList,
  removeErrorsFromList,
} = commonSlice.actions;

export default commonSlice.reducer;
